import useId from '../utils/useId';
import * as React from 'react';
export const hellomoneySvg = React.forwardRef(function hellomoneySvgInner(
  props,
  ref,
) {
  const id_0 = useId();
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: `url(#bi_hellomoney__a_${id_0})`,
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.28 18.446c-.33.498-.654.966-.952 1.45-.074.12-.126.337-.067.436.078.128.307.283.418.25.29-.085.563-.249.82-.415.312-.201.415-.483.416-.882.005-1.202.251-2.366.87-3.412.17-.288.439-.562.729-.725.49-.277.947-.04 1.096.505.18.655.054 1.3-.233 1.877-.404.808-.892 1.576-1.365 2.349-.103.17-.219.328-.062.479.125.12.32.235.483.233.458-.006.925-.476.994-.936.117-.786.665-1.365 1.373-1.442.59-.065 1.086.095 1.404.631.312.527.238 1.337-.159 1.855-.639.836-1.669.836-2.466.002-.886.8-1.962.959-2.532-.156-.41.36-.813.725-1.389.783-.629.064-1.037-.235-1.288-.788-1.267 1.094-2.714.959-3.335.146-.17.123-.328.282-.518.365-.283.123-.586.252-.887.273-.5.035-.77-.262-.747-.765.014-.289.089-.574.13-.862.02-.148.026-.299.039-.448l-.112-.059c-.16.212-.35.407-.472.638-.168.32-.261.679-.43.998-.093.178-.245.37-.42.452-.363.17-.595.011-.607-.39-.044-1.463.024-2.917.564-4.299.16-.41.397-.804.663-1.157.255-.34.642-.478 1.072-.33.331.114.488.473.477.975-.013.624-.278 1.151-.645 1.627-.303.393-.63.772-.983 1.121-.227.226-.261.457-.207.74.251-.32.458-.67.749-.925.232-.204.552-.354.856-.418.376-.08.556.118.508.503-.057.444-.176.88-.24 1.323-.023.163.034.339.055.509.172-.054.37-.071.51-.17.276-.194.464-.425.51-.819.104-.873.937-1.456 1.816-1.36.69.076 1.023.818.581 1.391-.187.244-.501.401-.78.56-.173.1-.387.131-.6.199.152.303.438.31.69.297.628-.032 1.116-.375 1.536-.812.067-.069.063-.224.063-.338-.007-1.208.218-2.368.771-3.443.161-.313.404-.617.682-.83.539-.414 1.112-.172 1.268.487.178.753-.072 1.437-.35 2.114-.084.202-.189.394-.297.613Zm-.969-.926C11 18.5 11 18.5 11.1 19c0 0 .435-.48.583-.779.336-.676.62-1.373.568-2.15-.008-.122-.06-.355-.184-.355-.098.003-.232.155-.27.26-.175.489-.321.987-.486 1.544Zm2.59.55c-.167.617-.113.79-.113 1.005.65-.886 1.165-1.81 1.16-2.921 0-.146 0-.404-.169-.438-.134 0-.278.21-.32.345-.2.643-.367 1.297-.559 2.008Zm3.56 1.501c-.026-.32-.093-.63-.489-.647-.377-.017-.524.266-.585.58-.04.2-.079.431-.011.608.072.19.24.41.418.475.255.095.466-.106.558-.35.07-.188.08-.4.11-.666ZM4.367 16.627l-.355 1.504.102.04c.208-.308.46-.595.612-.929.165-.365.254-.768.336-1.163.022-.104-.103-.238-.161-.358-.093.082-.216.147-.272.25-.103.189-.166.4-.262.657Zm4.179 2.252c-.498-.048-.803.313-.764.974.244-.111.486-.187.687-.324.213-.146.324-.363.077-.65Zm-1.539 4.275c-.113.37-.262.705-.283 1.049-.042.68-.012 1.365-.012 2.07h-.605v-2.35c0-.998-.219-1.342-.867-1.365-.873-.03-1.587.585-1.618 1.423-.022.571-.005 1.145-.005 1.717v.567H3v-4.19h.538l.06.705c.448-.477.936-.789 1.571-.817.676-.03 1.177.215 1.486.883.509-.618 1.127-.94 1.916-.88.626.047 1.162.48 1.186 1.098.04 1.058.01 2.12.01 3.204h-.57v-2.307c-.006-.517.112-1.121-.533-1.338-.629-.212-1.186.018-1.657.53Zm16.052 2.996c-1.252.497-2.49.036-2.996-1.087a2.213 2.213 0 0 1 .984-2.854c1.232-.657 2.758.05 2.954 1.404l-3.283 1.324c.473.932 1.399 1.077 2.538.418.044.035.102.067.142.114.074.084.138.178.227.297-.189.129-.361.247-.566.383Zm-2.404-2.658c-.129.277-.162.586-.162.892l2.754-1.108c-.012.067.012-.067 0 0 0 0-.092-.225-.39-.434-.367-.257-.85-.313-1.28-.19-.414.118-.706.377-.922.84Zm-9.191-1.207c1.043-.54 2.09-.4 2.812.353.664.695.806 1.76.343 2.581-.446.793-1.341 1.253-2.216 1.14-.909-.118-1.668-.764-1.897-1.615-.25-.926.08-1.794.958-2.46Zm2.42.834c-.492-.528-1.081-.717-1.772-.475-.627.22-.988.684-1.06 1.34a1.58 1.58 0 0 0 .957 1.656 1.627 1.627 0 0 0 1.869-.433c.51-.608.527-1.293.006-2.088Zm13.274 1.415c.37-.732.723-1.432 1.079-2.13.21-.413.211-.412.763-.305-.056.134-.104.264-.165.387-1.027 2.058-2.062 4.113-3.076 6.178-.167.339-.36.475-.794.303.224-.451.392-.932.675-1.333.66-.934.642-1.787.015-2.757-.552-.854-.932-1.82-1.4-2.76.416-.16.632-.061.807.307.496 1.039 1.03 2.06 1.584 3.16.186-.381.34-.7.512-1.05ZM15.756 22.59v-.522l.528-.024.072.762c.527-.63 1.145-.897 1.894-.836.554.045 1.088.392 1.12.923.065 1.117.02 2.24.02 3.383h-.542c0-.76.003-1.507-.002-2.253-.001-.261 0-.525-.038-.782-.06-.407-.327-.626-.727-.677a1.52 1.52 0 0 0-1.72 1.462c-.021.732-.005 1.465-.005 2.235h-.6v-3.67Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm24.558 12.73.082-.007a4.345 4.345 0 0 1-.082.008Z',
      fill: '#FEF66F',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M26.315 12.232a4.875 4.875 0 0 0-6.546-6.547 4.875 4.875 0 0 1 9.23 2.19 4.875 4.875 0 0 1-2.684 4.357Z',
      fill: '#FEF66F',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M26.833 10.042c0 .787-.186 1.531-.518 2.19a4.843 4.843 0 0 1-1.675.491 4.875 4.875 0 0 0-5.363-5.363 4.843 4.843 0 0 1 .491-1.675 4.875 4.875 0 0 1 7.065 4.357Z',
      fill: '#FFE828',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M24.667 12.208c0 .174-.01.346-.027.515a4.426 4.426 0 0 1-.24.02 4.875 4.875 0 0 1-5.124-5.382 4.875 4.875 0 0 1 5.39 4.848Z',
      fill: '#FFCB21',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M19.277 7.36a4.843 4.843 0 0 0-1.675.492 4.896 4.896 0 0 1 2.167-2.167 4.843 4.843 0 0 0-.492 1.675Zm5.363 5.363a4.845 4.845 0 0 0 1.675-.491 4.896 4.896 0 0 1-2.167 2.166 4.842 4.842 0 0 0 .491-1.675Z',
      fill: '#ECCD24',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm24.558 12.73.081-.007a4.842 4.842 0 0 1-.491 1.675 4.875 4.875 0 0 1-6.546-6.547 4.843 4.843 0 0 1 1.675-.49 4.875 4.875 0 0 0 5.28 5.37Z',
      fill: '#FFB201',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M19.577 18.336c-.082-.793-.921-1.155-1.662-1.451A4.877 4.877 0 0 1 17.535 8c-.258.512-.39 1.075-.436 1.67-.026.345 0 .693.075 1.032.553 2.526 2.3 4.198 4.826 4.198.788 0 2-.4 2-.43a9.27 9.27 0 0 1-1.108 1.594c-2.508 2.87-3.438 3.334-3.438 3.334s.185-.462.123-1.062Z',
      fill: '#FF9000',
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_hellomoney__a_${id_0}`,
          x1: 16,
          y1: 0,
          x2: 16,
          y2: 32,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#F26F26',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#EA2C01',
        }),
      ),
    ),
  );
});
hellomoneySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var hellomoney = {
  category: 'brand',
  colorable: false,
  name: 'hellomoney',
  svg: hellomoneySvg,
};
